export default __webpack_public_path__ + "static/media/Diafane_presenze_Giuliano_Censini_30_x_30.aa496196.jpg";